// state=clean - это состояние. когда мы выбираем пункт с левой стороны.
// state=1sideChecked - состояние когда слева что - то выбрано
// и нужно найти пару справа.

function matching() {
  var state = "clean";
  $(".js-match").on("click", function(e){
    if (!$(this).hasClass("disabled")) {
      switch (state) {
        case "clean":
          $(this).toggleClass("checked");
          if (checkConnection(this)) {
            unCheckConnected(this);
            state = "clean";
          } else {
            deactiveSiblings(this);
            activateSide("2",true);
            state = "1sideChecked";
          }
        break
        case "1sideChecked":
          $(this).toggleClass("checked");
          if (checkConnection(this)) {
            unCheckConnected(this);
            state = "1sideChecked";
          } else {
            state = "clean";
            if ($(this).data("side") == 2) {
              createConnection(this);
              deactiveSiblings(this);
            }
            activateSide("1",true);
            activateSide("2",false);
          }
        break
      }
    }
  })

  $(window).on("resize", function(){
    reWrite($(".connected[data-side='1']"))
  })

  //создание связи
  function createConnection(el){
    if (!$(el).hasClass("connected")) {
      var side1Checked = $(".js-match-cont1").find(".checked");
      side1Checked.each(function(){
        if (!$(this).hasClass("connected")) {
          $(this).addClass("connected");
          $(el).addClass("connected");
          $(el).attr("data-item", $(this).data("item"));
          $(el).data("item", $(this).data("item"));

          writeLines($(el).find(".js-control"),$(this).find(".js-control"), $(".matching"))
        }
      })
    }
  }

  //проверка на наличие связи
  function checkConnection(el) {
    if ($(el).hasClass("connected")) {
      return true
    } else
      return false
  }

  //При разрыве связи
  function unCheckConnected(el) {
    //удаляем связующие классы
    var question = $(el).data("item");
    $("[data-item="+question+"]").each(function(){
      $(this).removeClass("checked connected");
    })
    //Смотрим нет ли слева выделенных блоков без связи
    if (side1Checked()) {
      var el = side1Checked();
      deactiveSiblings(el);
    } else {
      $(".js-match-cont2").find("[data-item="+question+"]").addClass("disabled");
    }
    //убираем связь
    $(".js-match-cont2").find("[data-item="+question+"]").data("item", "");
    $(".js-match-cont2").find("[data-item="+question+"]").removeAttr("data-item");

    //убираем линию
    $("#canvas"+question).remove();
  }

  function reWrite(el) {
    var checked = {}
    //delete all canvases
    el.each(function(index){
      var question = $(this).data("item");
      $("#canvas"+question).remove();
      var side1obj = $(".connected[data-item="+question+"]").eq(0);
      var side2obj = $(".connected[data-item="+question+"]").eq(1);
      writeLines(side1obj.find(".js-control"),side2obj.find(".js-control"), $(".matching"))
    })





  }

  // При разрыве связи, смотрим нет на левой стороне
  // выделенных, не связанных блоков.
  function side1Checked(){
    var result = false;
    $(".js-match-cont1").find(".js-match.checked").each(function(){
      if (!$(this).hasClass("connected")) {
        result = this
      }
    });
    return result;
  }
  /*deactivate side siblings*/
  function deactiveSiblings(el) {
    $(el).siblings().each(function(){
      if (!$(this).hasClass("connected")) {
        $(this).addClass("disabled");
      }
    })
  }

  /*activate/deactivate side*/
  function activateSide(number,bool){
    if (bool){
      $(".js-match-cont"+number).find(".js-match").each(function(){
        $(this).removeClass("disabled");
      })
    } else {
      $(".js-match-cont"+number).find(".js-match").each(function(){
        if (!$(this).hasClass("connected")) {
          $(this).addClass("disabled");
        }
      })
    }
  }



}


//рисование линй
function writeLines(startObj, endObj, maincont){
  //получаем координаты
  var coords = getCoordinates(startObj, endObj, maincont);
  var start = coords.start;
  var end = coords.end;
  //создаем и добавляем канвас
  var canvas = createCanvas(startObj, maincont);
  //рисуем линию
  write(start,end,canvas);

  function createCanvas(startObj) {
    var id = "canvas"+ startObj.parents(".js-match").data("item");
    var canvasWidth = maincont.width();
    var canvasWidth = maincont[0].scrollWidth;
    var canvasHeight = maincont.height();
    var canvas = $("<canvas></canvas>", {
      id : id,
      class: "matching__canvas",
    })
    canvas.attr("width",canvasWidth);
    canvas.attr("height",canvasHeight);
    maincont.append(canvas);
    return $('#'+id);
  }
  function getCoordinates(startObj, endObj, maincont) {
    var coords = {
      "start": {},
      "end"  : {}
    };
    var scrolled = maincont[0].scrollLeft;
    coords.start.top = startObj.position().top + 10;
    coords.end.top = endObj.position().top + 10;
    coords.start.left = startObj.position().left + 10 + scrolled;
    coords.end.left = endObj.position().left + 10 + scrolled;

    return (coords)
  }
  function write(start,end,canvas) {
    var ctx = canvas[0].getContext('2d');
    ctx.strokeStyle = "#a3c1da";
    ctx.lineWidth = "2";
    ctx.setLineDash([5, 6]);
    ctx.moveTo(start.left,start.top);
    ctx.lineTo(end.left,end.top);
    ctx.lineCap = "round";
    ctx.stroke();
  }
}